import type { SimCard } from '@racemap/sdk/schema/simCard';
import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import useSWR, { type SWRConfiguration } from 'swr';
import { apiClient } from '.';

interface UseSimParams {
  iccid?: string | null;
  simId?: string | null;
  msisdn?: string | null;
  friendlyName?: string | null;
}

export function useSimCard(
  { iccid, simId, msisdn, friendlyName }: UseSimParams,
  options?: SWRConfiguration,
): { sim: SimCard | undefined | null; isLoading: boolean; error: Error } {
  const { data, isLoading, error } = useSWR(
    iccid != null || simId != null ? ['GET', 'SIM', iccid, simId] : null,
    async ([, , iccid, simId]) => {
      if (iccid == null && simId == null && msisdn == null && friendlyName == null) return null;

      if (simId != null) {
        return await apiClient.getSim({ simId });
      }
      return await apiClient.lookupSim({
        iccid: iccid || undefined,
        msisdn: msisdn || undefined,
        friendlyName: friendlyName || undefined,
      });
    },
    {
      revalidateIfStale: false,
      refreshInterval: OneMinuteInMillis * 5,
      keepPreviousData: true,
      ...options,
    },
  );

  return { sim: data, isLoading, error };
}
